import React from 'react';
import styled, { css } from 'styled-components/macro';
import { navigate } from 'gatsby';

import Avatar from '@material-ui/core/Avatar';

import AccessTime from '@material-ui/icons/AccessTime';
import LocationOn from '@material-ui/icons/LocationOn';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Work from '@material-ui/icons/Work';

import { helperJobConversion } from '../../services/helperJobConversion';
import { makeUrlGoogleCompliant } from '../../services/helpers';

import fontSize from '../../assets/fontSize';
import colors from '../../assets/colors';

const limitAddressLines = css`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const Card = styled.div`
  box-sizing: border-box;
  width: ${({ isCard, fullWidth }) =>
    isCard ? (fullWidth ? '100%' : '290px') : '100%'};
  border-radius: 6px;

  ${({ isCard }) =>
    isCard &&
    css`
      border: ${`1px solid ${colors.grey}`};
      cursor: pointer;

      :hover {
        background-color: rgba(0, 0, 0, 0.02);
      }
    `}

  @media (min-width: 500px) {
    width: ${({ isCard, fullWidth }) =>
      isCard ? (fullWidth ? '100%' : '380px') : '100%'};
  }
`;
const CardContent = styled.div`
  padding: ${({ isCard }) => isCard && '0.75rem'};
`;
const AggregateHeader = styled.div`
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.appleGreen};
  border-radius: 6px 6px 0 0;
`;
const AggregateTitle = styled.p`
  margin: 0;
  font-size: ${fontSize.medium};
`;
const PosterDetails = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${({ isCard }) => (isCard ? '0.75rem' : '1rem')};
  border-bottom: 1px solid ${colors.lightGrey};
`;
const PosterName = styled.div`
  font-size: ${({ isCard }) => (isCard ? fontSize.large : fontSize.xLarge)};
  font-weight: ${({ isCard }) => (isCard ? 400 : 600)};
  margin-left: 1rem;
`;
const JobDetailsBreakdown = styled.div`
  margin-top: ${({ isCard }) => (isCard ? '0.75rem' : '1rem')};
`;
const BreakdownRow = styled.div`
  display: flex;
  align-items: ${({ noAlign }) => !noAlign && 'center'};
  margin-top: ${({ marginTop, isCard }) =>
    marginTop ? (isCard ? '0.5rem' : '1rem') : 0};
`;
const BreakdownTitle = styled.div`
  font-size: ${({ isCard }) => (isCard ? fontSize.large : fontSize.xLarge)};
  font-weight: bold;
  margin-left: 1rem;
`;
const BreakdownText = styled.div`
  font-size: ${({ small }) => (small ? fontSize.medium : fontSize.large)};
  color: ${({ highlight }) => highlight && colors.green};
  font-weight: ${({ bold }) => bold && '600'};
  margin: 0 1rem;
  ${({ isAddress }) => isAddress && limitAddressLines}
`;
const FeeIcon = styled(MonetizationOn)`
  && {
    color: ${colors.green};
  }
`;

const AggregateJobCard = props => {
  const {
    totalJobs,
    posterId,
    helperType,
    shifts,
    posterName,
    location,
    avatar,
    fee,
    isCard,
    fullWidth
  } = props;

  const handleClickCard = () => {
    navigate(makeUrlGoogleCompliant(`/jobs/${helperType}/${posterId}`));
  };

  return (
    <Card
      onClick={isCard ? () => handleClickCard() : () => {}}
      isCard={isCard ? 1 : 0}
      fullWidth={fullWidth}
    >
      <AggregateHeader>
        <AggregateTitle>{totalJobs} jobs available</AggregateTitle>
      </AggregateHeader>
      <CardContent isCard={isCard ? 1 : 0}>
        <PosterDetails isCard={isCard ? 1 : 0}>
          <Avatar
            src={avatar}
            alt={posterName}
            style={{ width: '50px', height: '50px' }}
          />
          <PosterName isCard={isCard ? 1 : 0}>{posterName}</PosterName>
        </PosterDetails>
        <JobDetailsBreakdown isCard={isCard ? 1 : 0}>
          <BreakdownRow isCard={isCard ? 1 : 0}>
            <Work />
            <BreakdownTitle isCard={isCard ? 1 : 0}>
              {helperJobConversion(helperType)}
            </BreakdownTitle>
          </BreakdownRow>
          <BreakdownRow isCard={isCard ? 1 : 0} marginTop>
            <FeeIcon />
            <BreakdownText isCard={isCard ? 1 : 0} bold highlight>
              {fee}
            </BreakdownText>
          </BreakdownRow>
          <BreakdownRow isCard={isCard ? 1 : 0} marginTop>
            <LocationOn />
            <BreakdownText isCard={isCard ? 1 : 0} isAddress>
              {location}
            </BreakdownText>
          </BreakdownRow>
          <BreakdownRow isCard={isCard ? 1 : 0} marginTop>
            <AccessTime />
            <BreakdownText isCard={isCard ? 1 : 0} small>
              {shifts}
            </BreakdownText>
          </BreakdownRow>
        </JobDetailsBreakdown>
      </CardContent>
    </Card>
  );
};

export default AggregateJobCard;
